<template>
    <div>
        <slot name="prefix"></slot>
        <span :class="className">{{ humanStatus | registrationCategoryStatus }}</span>
        <slot name="postfix"></slot>
    </div>
</template>

<script>

import {registrationCategoryStatus} from '../../filters/registration_category_status'

export default {
    name: "StatusBadge",
    props: {
        humanStatus: {
            type: String,
            required: true
        }
    },
    filters: {
        registrationCategoryStatus,
    },
    computed: {
        className() {
            switch (this.humanStatus) {
                case 'human_status_open':
                    return 'open';

                case 'human_status_closed':
                case 'human_status_full':
                    return 'closed';

                case 'human_status_waiting_list':
                    return 'waiting-list';
            }
        }
    }
}
</script>

<style scoped lang="scss">

$open: #6fa551;
$closed: #dc143c;
$waitingList: #ecb618;

.open {
    color: $open;
}

.closed {
    color: $closed;
}

.waiting-list {
    color: #ecb618;
}

span {
    padding-left: 2rem;
    font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Utility/StatusBadge.vue